import { render, staticRenderFns } from "./index_copy.vue?vue&type=template&id=a795dd7c&scoped=true&"
import script from "./index_copy.vue?vue&type=script&lang=js&"
export * from "./index_copy.vue?vue&type=script&lang=js&"
import style0 from "./index_copy.vue?vue&type=style&index=0&id=a795dd7c&lang=scss&scoped=true&"
import style1 from "./index_copy.vue?vue&type=style&index=1&id=a795dd7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a795dd7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a795dd7c')) {
      api.createRecord('a795dd7c', component.options)
    } else {
      api.reload('a795dd7c', component.options)
    }
    module.hot.accept("./index_copy.vue?vue&type=template&id=a795dd7c&scoped=true&", function () {
      api.rerender('a795dd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/index_copy.vue"
export default component.exports